module.exports = Object.freeze({
    none: 'none',
    owner: 'Owner',
    coordinator: 'Coordinator',
    giver: 'Volunteer',
    receiver: 'Senior'
});
